import common from './common.json';

export const nlLocales = {
  common,
};
